import appLocaleData from 'react-intl/locale-data/ja';
import jaMessages from '../locales/ja_JP.json';
import jaMessagesVariant from '../variant/ja_JP.json';

const JaLang = {
  messages: {
    ...jaMessages,
    ...jaMessagesVariant,
  },
  locale: 'ja-JP',
  data: appLocaleData,
};
export default JaLang;
